import {NSFunctions} from './utils/functions';
import {xCore, xCoreHelper} from './core';
import { URN as NSURN } from './utils/urn';
import { NSMessages } from './utils/messages';
import { NSTables } from './utils/tables';
import { NSDataTypes } from './utils/data_types';
import { NSDataModelInfo } from './data_model_info';
import { NSPageLabels } from './page_labels';
import { NSPageSidepanel } from './page_sidepanel';
import { NSServerCalls } from './utils/servercalls';
import { NSObjDetailsGeo } from './obj_details_geo';
import { NSObjDetailsEdit } from './obj_details_edit';
import { NSObjJoinList } from './obj_join_list';
import { NSDateDatetime } from './utils/date_datetime';
import { Map as NSModule_Map } from './map';
import { NSUserFunctionPermissions } from './user_function_permissions';
import { NSGeoJson } from './utils/geojson';
import { NSMiniClientMain } from './mini_client_main';
import { toLonLat } from 'ol/proj';
import { NSCRS } from './utils/crs';
import { NSFeaturesSelect } from './map_features_select';
import { Overlays } from './overlays';
import { NSGeometryClipboard } from './geometry_clipboard.js'
import { NSToolDraw } from './tool_draw';

import SendIcon from 'bootstrap-icons/icons/send.svg?raw';
import PencilIcon from 'bootstrap-icons/icons/pencil.svg?raw';
import LinkIcon from 'bootstrap-icons/icons/link-45deg.svg?raw';
import EyeIcon from 'bootstrap-icons/icons/eye.svg?raw';
import EyeSlashIcon from 'bootstrap-icons/icons/eye-slash.svg?raw';
import CopyIcon from 'bootstrap-icons/icons/clipboard-plus.svg?raw'; //'bootstrap-icons/icons/copy.svg?raw';
import DrawIcon from 'bootstrap-icons/icons/pencil-square.svg?raw'; //'bootstrap-icons/icons/copy.svg?raw';

export let NSObjDetails = {};

NSObjDetails.init = function()
{
    NSObjDetailsPrivate.init();
	
	this.f_open_details_by_feature = 	function () { return NSObjDetailsPrivate.f_open_details_by_feature.apply( NSObjDetailsPrivate, arguments ); };
	this.f_open_details_by_urn =		function () { return NSObjDetailsPrivate.f_open_details_by_urn.apply( NSObjDetailsPrivate, arguments ); };
	this.f_hide_read_and_edit_section_if_they_belong_to_disabled_table =		
										function () { return NSObjDetailsPrivate.f_hide_read_and_edit_section_if_they_belong_to_disabled_table.apply( NSObjDetailsPrivate, arguments ); };
	this.f_hide_read_and_edit_section =	function () { return NSObjDetailsPrivate.f_hide_read_and_edit_section.apply( NSObjDetailsPrivate, arguments ); };
	this.f_hide_read_section =			function () { return NSObjDetailsPrivate.f_hide_read_section.apply( NSObjDetailsPrivate, arguments ); };
	this.f_show_read_section = 			function () { return NSObjDetailsPrivate.f_show_read_section.apply( NSObjDetailsPrivate, arguments ); };
 

	this.f_show_joins_ =				function () { return NSObjDetailsPrivate.o_read.f_show_joins_.apply( NSObjDetailsPrivate.o_read, arguments ); };
	this.f_geometry_button_click_ =		function () { return NSObjDetailsPrivate.o_read.f_geometry_button_click_.apply( NSObjDetailsPrivate.o_read, arguments ); };
	this.f_copy_object_trail_ =		function () { return NSObjDetailsPrivate.o_read.f_copy_object_trail_.apply( NSObjDetailsPrivate.o_read, arguments ); };
	this.f_draw_object_trail_ =		function () { return NSObjDetailsPrivate.o_read.f_draw_object_trail_.apply( NSObjDetailsPrivate.o_read, arguments ); };
										
	
	NSObjDetailsPrivate.objs.init();

	this.objs = NSObjDetailsPrivate.objs;

	window.NSObjDetails = NSObjDetails;
	//window.NSObjDetails_ = NSObjDetails;
	window.NSObjDetailsPrivate_ = NSObjDetailsPrivate;
	
}



let NSObjDetailsPrivate =
{
	private_objs: 
	{
		s_e_div_editorpage_holder_id: "editorpage",
		s_e_div_read_id: "editorpage_read",
		s_e_div_edit_id: "editorpage_edit",
		
		e_div_editorpage_holder: null,
		e_editorpage_read: null,
		
		e_table_container: null,
		e_button_go_to_bounds: null,
		e_button_edit_details: null,
		e_button_details_unselect: null,
		
		e_span_obj_details_title: null,
		e_div_obj_details_coordinates: null,
		
		o_details: null,
		
		o_bb: null, // LatLng bounding box that contains the object

		a_s_table_urn_without_permissions: [],	// used to store table loads failed because of lack of permissions for joins.

		CONSTS:
		{
			s_CONST_INHERITED_GEOM_NAME: "GEOM_INHERITED_FROM_ANOTHER_TABLE"
		}
		
		
	},
	
	init: function()
	{
		var this_ = this;
		var private_objs = this.private_objs;
		
		var moduleName = "NSObjDetails";
		private_objs.settings = xCore.modules[moduleName].settings;

		private_objs.e_div_editorpage_holder = document.getElementById(private_objs.s_e_div_editorpage_holder_id)
		private_objs.e_editorpage_read = document.getElementById(private_objs.s_e_div_read_id);

		let s_label_obj_details_button_goto_tooltip = NSPageLabels.f_get_label_text_by_internal_name("obj_details_button_goto_tooltip");
		let s_label_obj_details_button_edit_tooltip = NSPageLabels.f_get_label_text_by_internal_name("obj_details_button_edit_tooltip");
		let s_label_obj_details_button_link_tooltip = NSPageLabels.f_get_label_text_by_internal_name("obj_details_button_link_tooltip");
		let s_label_obj_details_button_clean_tooltip = NSPageLabels.f_get_label_text_by_internal_name("obj_details_button_clean_tooltip");
		
		var e_editorpage_read = private_objs.e_editorpage_read;
		e_editorpage_read.innerHTML = `
			<div class="actions-buttons-group btn-group btn-group-sm" role="group" aria-label="...">
				<button id="button_go_to_bounds" type="button" class="btn btn-sm btn-outline-secondary" title="${s_label_obj_details_button_goto_tooltip}">${SendIcon}</button>
				<button id="button_edit_details" type="button" class="btn btn-sm btn-outline-secondary" title="${s_label_obj_details_button_edit_tooltip}">${PencilIcon}</button>
				<button id="button_copy_object_link" type="button" class="btn btn-sm btn-outline-secondary" title="${s_label_obj_details_button_link_tooltip}">${LinkIcon}</button>
				<button id="button_details_unselect" type="button" class="btn btn-sm btn-outline-secondary" title="${s_label_obj_details_button_clean_tooltip}">${EyeSlashIcon}</button>
			</div>
			<div class="editor-title"></div>
			<div class="table-container"></div>
		`;
		
		private_objs.e_table_container = e_editorpage_read.querySelector(".table-container");
		private_objs.e_button_go_to_bounds = e_editorpage_read.querySelector("#button_go_to_bounds");
		private_objs.e_button_edit_details = e_editorpage_read.querySelector("#button_edit_details");
		private_objs.e_button_object_link = e_editorpage_read.querySelector("#button_copy_object_link");
		private_objs.e_button_details_unselect = e_editorpage_read.querySelector("#button_details_unselect");
		
		private_objs.e_span_obj_details_title = e_editorpage_read.querySelector(".editor-title");

		private_objs.e_div_obj_details_coordinates = private_objs.e_div_editorpage_holder.querySelector(".page-footer");
		
		private_objs.e_button_go_to_bounds.onclick = function ()
		{
				this_.o_read.f_go_to_bounds();
		}
		
		private_objs.e_button_edit_details.onclick = function ()
		{
				this_.o_read.f_edit_details();
		}
		
		private_objs.e_button_details_unselect.onclick = function ()
		{
				NSObjDetailsPrivate.f_hide_read_and_edit_section();
				xCore.state.selected_objects = [];
		}
		
		private_objs.e_button_object_link.onclick = function ()
		{
			if(xCore.state.selected_objects &&  Object.keys(xCore.state.selected_objects).length > 0 ){
				
				var base_url = window.location.href;
				
				if(base_url.indexOf("#") > 0 )
					base_url = window.location.href.split("#")[0];	
				
				if(base_url.indexOf("?") > 0 )
					base_url = window.location.href.split("?")[0];	
				
				
				let text_to_copy = base_url + "?urn=" + xCore.state.selected_objects[0];
				
				if (!navigator.clipboard){
					// use old commandExec() way
					const el = document.createElement('textarea');
					el.value = text_to_copy;				
					document.body.appendChild(el);
					el.select();
					document.execCommand('copy');
					document.body.removeChild(el);	
				} else{
					//new way
					navigator.clipboard.writeText(text_to_copy).then(
						function(){
							//alert("yeah!"); // success 
						})
					  .catch(
						 function() {
							//alert("err"); // error
					  });
				}    
				
				
				let s_label_obj_details_link_creation_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_link_creation_message")
				NSMessages.f_show_information( s_label_obj_details_link_creation_message , 3000 );
			}
		}

		this.f_hide_read_section();		
	},
	
	f_show_read_section: function()
	{
		var private_objs = this.private_objs;
		
		NSObjDetailsEdit.f_hide_edit_section();
		
		private_objs.e_editorpage_read.style.display = "";
	},
	f_hide_read_section: function()
	{
		var private_objs = this.private_objs;
		private_objs.e_editorpage_read.style.display = "none";
	},
	f_hide_read_and_edit_section_if_they_belong_to_disabled_table: function(s_table_urn)
	{
		var private_objs = this.private_objs;
		
		
		if(private_objs.o_details != null && private_objs.o_details.feature != null)
		{
			var s_feature_urn = private_objs.o_details.s_urn;
			//window.featuree_ = private_objs.o_details.feature;

			//console.log(private_objs.o_details);
			let s_o_details_table_urn = NSURN.f_create_table_urn_from_record_urn(s_feature_urn);
			let a_active_layers = Overlays.f_get_all_active_overlays().filter((layer) => layer.tree_node.urn === s_o_details_table_urn);
			
			if(s_o_details_table_urn == s_table_urn && a_active_layers.length === 0)
			{
				this.f_hide_read_and_edit_section();
			}
			
		}
		
		
	},
	f_hide_read_and_edit_section: function()
	{
		if (this.private_objs.o_details) NSFeaturesSelect.f_remove_current_selection_highlight();
		
		this.private_objs.e_div_obj_details_coordinates.innerHTML = "";
		this.private_objs.o_details = null;
		
		this.f_hide_read_section();
		NSObjDetailsEdit.f_hide_edit_section();				
		NSObjJoinList.f_destroy();
	},
	

/*
		o_in:
		{
			tree_node_id,
			s_urn, 						// record urn
			b_clean_join_list,
			o_ll,						// (optional) - {LatLng}
			o_geo_json					// {GeoJson}
			s_geometry_internal_name	// internal name of the geometry field,
			b_is_icon,
			a_icon_size_xy,				// [width, height]
			b_go_to						// automaticaly executes go to object function 
		}
	*/
	f_open_details_by_feature: function (o_in)
	{
		var this_ = this;
		let tree_node_id = o_in.tree_node_id;
		var s_urn = o_in.s_urn;
		var b_clean_join_list = o_in.b_clean_join_list;
		var o_ll = o_in.o_ll;
		var o_geo_json = o_in.o_geo_json;
		var s_geometry_internal_name = o_in.s_geometry_internal_name;
		var b_is_icon = o_in.b_is_icon;
		var a_icon_size_xy = o_in.a_icon_size_xy;
		var b_go_to = o_in.b_go_to;


		//var o_bbox = o_geo_json.bbox;
		let o_bbox = NSGeoJson.f_get_bounds_from_geojson_geometry(o_geo_json.geometry);
		var o_feature = o_geo_json;
		var o_joined_object_counts = null;
		
		this.f_remove_empty_properties_from_feature(o_feature);
		
						
		var o_obj_details = new NSObjDetails.objs.ObjDetails(
			{
				tree_node_id: tree_node_id,
				s_urn: s_urn,
				bbox: o_bbox,
				feature: o_feature,
				joined_object_counts: o_joined_object_counts,
				b_is_icon: b_is_icon,
				a_icon_size_xy: a_icon_size_xy,
				b_go_to: b_go_to
			}
		);	
		
		//this_.f_open_details(o_obj_details, b_clean_join_list);		
		this_.f_add_joined_object_counts_and_open_details(o_obj_details, b_clean_join_list);

		
	},

	f_remove_empty_properties_from_feature: function(o_feature)
	{
		for (let a in o_feature.properties){
			if(o_feature.properties[a] == null || String(o_feature.properties[a]) == ""){
				delete o_feature.properties[a]
			}
		}
	},

	/**
		@example
		o_in:
		{
			tree_node_id,
			s_urn, 
			b_clean_join_list,
			o_ll,						// (optional) - {google.maps.LatLng}
			o_geo_json					// (optional) - {GeoJson}
			s_geometry_internal_name	// internal name of the geometry field
			b_is_icon,
			a_icon_size_xy,				// [width, height]
			b_go_to,					// automaticaly executes go to object function 
			f_callback					// function to callback when object details are loaded
		}
	*/
	f_open_details_by_urn: function (o_in)
	{
		/*
		console.log("f_open_details_by_urn - o_in:")
		console.log(o_in)
		*/
		var this_ = this;
		var tree_node_id = o_in.tree_node_id;
		var s_urn = o_in.s_urn;
		var b_clean_join_list = o_in.b_clean_join_list;
		var o_ll = o_in.o_ll;
		//var o_geo_json = o_in.o_geo_json;
		var s_geometry_internal_name = o_in.s_geometry_internal_name;
		var b_is_icon = o_in.b_is_icon;
		var a_icon_size_xy = o_in.a_icon_size_xy;
		var b_go_to = o_in.b_go_to;
		var f_callback = o_in.f_callback;
		
	
		var	f_get_obj_details_process_result = function (o_resp)
		{

			if(o_resp != null && o_resp.features.length > 0)
			{
				let o_gj_feature = o_resp.features[0];


				//let o_bbox = o_gj_feature.bbox;
				let o_bbox = NSGeoJson.f_get_bounds_from_geojson_geometry(o_gj_feature.geometry);
				let o_joined_object_counts = null; //o_resp.object_info[s_urn].joined_object_counts;

				o_gj_feature.id = s_urn;				
				
				this_.f_remove_empty_properties_from_feature(o_gj_feature);
				
								
				var o_obj_details =  new NSObjDetails.objs.ObjDetails(
					{
						tree_node_id: tree_node_id,
						s_urn: s_urn,
						bbox: o_bbox,
						feature: o_gj_feature,
						joined_object_counts: o_joined_object_counts,
						b_is_icon: b_is_icon,
						a_icon_size_xy: a_icon_size_xy,
						b_go_to: b_go_to,

						f_callback_when_all_info_is_loaded: f_callback
					}
				);	
				
				//this_.f_open_details(o_obj_details, b_clean_join_list);		
				this_.f_add_joined_object_counts_and_open_details(o_obj_details, b_clean_join_list);


			}
			
		};
		

		var a_feature_urn_info = NSURN.f_get_urn_info(s_urn);
		let s_schema = a_feature_urn_info[1];
		let s_table_name = a_feature_urn_info[2];
		let s_record_key = a_feature_urn_info[3];
		
		let s_cache_limitation_param_value = NSFunctions.guidGenerator();
		NSServerCalls.geoserver.wfs.get_feature_by_id_list( s_table_name, s_record_key , null, 
			function (o_resp) {

				f_get_obj_details_process_result(o_resp);

			},
			s_cache_limitation_param_value
		);	
				
	},

	/*
	o_obj_details: {
					s_urn,
					bbox,
					feature,
					joined_object_counts,		
					b_is_icon,
					a_icon_size_xy	//[width, height]
				};	
				
	*/
	f_add_joined_object_counts_and_open_details: function(o_obj_details, b_clean_join_list)
	{
		let this_ = this;
		let private_objs = this_.private_objs;

		if(xCoreHelper.f_page_is_in_mini_client_mode())
		{
			/**
			 * 	Calling mini client on_map_object_select
			 *  On map object select "f_open_details_by_urn" or "f_open_details_by_feature" will be 
			 * 		called, and this is the first point common point
			 */
			let s_record_urn = o_obj_details.s_urn;
			NSMiniClientMain.f_on_map_obj_select(s_record_urn);
		}


		let f_get_external_join_info_cb = function(o_resp)
		{

			/*

			NSObjDetailsPrivate.objs.JoinInfo:
			{
				local_col,				-> col internal_name, ex "arvore_intervencao"
				local_col_db,			-> col internal_name, ex "id"
				external_col_urn,		-> ex: "urn__SEP__field__SEP__teste_01__SEP__tabela_03__SEP__id_tabela_01"
				join_count,				-> ex: "2"
				join_ids				-> ex: "2,4"
			}

				-> used in a_fk_field_info and a_external_join_info
			*/

			let a_fk_join_info = [];			// [{NSObjDetailsPrivate.objs.JoinInfo}]
			let a_external_join_info = [];		// [{NSObjDetailsPrivate.objs.JoinInfo}]
			
			
			o_resp.features.forEach( (o_feature) => { 

				let s_local_col = NSURN.f_get_urn_table_name(o_feature.properties.external_col_urn); // presently joins local internal_name is the name of the connected table
				//a_external_join_info.push(o_feature.properties);
				a_external_join_info.push( new NSObjDetailsPrivate.objs.JoinInfo(
					{
						local_col: 				s_local_col,
						local_col_db: 			o_feature.properties.local_col,
						external_col_urn: 		o_feature.properties.external_col_urn,
						join_count: 	o_feature.properties.external_join_count,
						join_ids: 		o_feature.properties.external_join_ids,
					}
				));
			} );

			let o_feature = o_obj_details.feature;
			let s_table_urn = NSURN.f_create_table_urn_from_record_urn(o_obj_details.s_urn);

			let a_fk_field_info = NSDataModelInfo.f_get_table_fk_joins_array_of_field_info_by_table_urn(s_table_urn);


			a_fk_field_info.forEach( (o_fk_field_info_i) => {
				let o_value_i = o_feature.properties[o_fk_field_info_i.internal_name_db];

				let s_col_i_name = o_fk_field_info_i.internal_name;
				let s_local_col = o_fk_field_info_i.target_table_internal_name; // presently joins local internal_name is the name of the connected table
				let s_external_col_urn = NSURN.f_create_field_urn(o_fk_field_info_i.target_schema_internal_name, o_fk_field_info_i.target_table_internal_name, o_fk_field_info_i.target_column_internal_name);
				let i_count = (o_value_i!=null && o_value_i != "")? 1 : 0;

				let o_fk_join_info = new NSObjDetailsPrivate.objs.JoinInfo(
					{
						local_col: s_local_col,
						local_col_db: o_fk_field_info_i.internal_name_db,
						external_col_urn: s_external_col_urn,
						join_count: i_count,
						join_ids: "" + o_value_i,
					}
				);
				a_fk_join_info.push(o_fk_join_info);
				

			});


			let joined_object_counts = {
				a_fk_join_info: 		a_fk_join_info,
				a_external_join_info: 	a_external_join_info,
				a_all_join_info: 		a_fk_join_info.concat(a_external_join_info)
			};
			o_obj_details.joined_object_counts = joined_object_counts;


			this_.f_open_details(o_obj_details, b_clean_join_list);


		};

		let f_get_external_join_info = function()
		{
			let o_data_in = 
			{
				s_record_urn: o_obj_details.s_urn
			};
	
			NSServerCalls.f_get_record_external_join_info(o_data_in, f_get_external_join_info_cb);
		}
		

		let s_table_urn = NSURN.f_create_table_urn_from_record_urn (o_obj_details.s_urn);
		
		let f_load_table_cb = function (b_error, s_message)
		{
			if (b_error)
			{
				NSMessages.f_show_information(s_message);
				return;
			}

			let a_child_joins_field_info = NSDataModelInfo.f_get_table_child_joins_array_of_field_info_by_table_urn(s_table_urn);

			//load DataModelInfo for all tables:
			let a_s_table_urn = [];
			a_child_joins_field_info.forEach( o_child_info_i => {
				let s_external_table_col_urn = o_child_info_i.external_col_urn;
				let s_child_table_urn = NSURN.f_create_table_urn_from_column_urn(s_external_table_col_urn);
				if(s_child_table_urn!=null && s_child_table_urn != "")
				{
					a_s_table_urn.push(s_child_table_urn);
				}
			});
			
			NSDataModelInfo.f_load_table_list____returning_promise(
				{
					a_s_table_urn: a_s_table_urn,
					b_full_info: false,
					b_dont_force_sucess_to_all_calls: true
				}
			).then((results) => {				
				// all_data_model_info_loaded, continue:
				// results = [{status: "fulfilled", value: ...}, {status: "rejected", reason: ...}, ...]

				const a_failed = []; 
				private_objs.a_s_table_urn_without_permissions = [];
				results.forEach((res, i) => { 
					if (res.status === "rejected") { 
						a_failed.push({ 
							urn: a_s_table_urn[i], 
							error: res.reason 
						}); 
						private_objs.a_s_table_urn_without_permissions.push(a_s_table_urn[i]);
					} 
				}); 
				
				if(a_failed.length>0){
					console.log("Assuming failed tables loads as tables without permission - Failed URNs:", a_failed);
				}
				
				f_get_external_join_info();
			});
			
			
		}


		
		/*
		o_in:
        {
            b_full_info,

            s_table_urn
            ||
            schema_name,
            table_name,
        }
		f_callback	->function (b_error, s_message)
		*/
		var o_in = 
		{			
			b_full_info: false,
			s_table_urn: s_table_urn
		}
		
		NSDataModelInfo.f_load_table(o_in, f_load_table_cb);

	},

	
	f_add_geojson_base_geometry_to_geojson_properties: function ()
	{
		let o_details = this.private_objs.o_details;

		let o_gj_feature = o_details.feature

		o_gj_feature.properties[o_gj_feature.geometry_name] = o_gj_feature.geometry;
	},
	
	f_open_details: function (o_details, b_clean_join_list)
	{
		let this_ = this;

		if(b_clean_join_list == true)
		{
			NSObjJoinList.f_destroy();
		}

		if (this.private_objs.o_details) NSFeaturesSelect.f_remove_current_selection_highlight();
		
		this.f_remove_empty_properties_from_feature(o_details.feature);
		
		this.private_objs.o_details = o_details;		
		
		let o_read = this.o_read;	
		
		let s_feature_urn = o_details.s_urn;

		//Add id to feature properties
		let s_record_id = NSURN.f_get_urn_record_id(s_feature_urn);
		o_details.feature.properties.id = s_record_id;


		this.f_add_geojson_base_geometry_to_geojson_properties();

		
		//Permissions:
		let b_has_edit_permissions = NSUserFunctionPermissions.f_has_permission_for_function_type_UPDATE_and_collection_urn(s_feature_urn);
		if(b_has_edit_permissions)
		{
			o_read.f_button_edit_details_show();
		}
		else
		{
			o_read.f_button_edit_details_hide();
		}
		

		this_.f_open_details_part_2();

		
	},

	/**
	 * @return {Promise}
	 */
	f_process_feature_spatial_context: function()
	{
		let this_ = this;
		let private_objs_global = this.private_objs;
		let o_details = private_objs_global.o_details;
		
		//let s_table_urn = NSURN.f_create_table_urn_from_record_urn(o_details.s_urn);
		//let o_table_info = NSDataModelInfo.f_get_table_info(s_schema_internal_name, s_table_internal_name);

		let o_gj_feature = o_details.feature;
		let b_get_spatial_context = ( o_gj_feature.geometry != null)? false : true;


		if(b_get_spatial_context)
		{
			return new Promise ( (resolve, reject) => {
				let o_promise_gcs = NSServerCalls.f_geospatial_context_search({s_record_urn: o_details.s_urn});
				o_promise_gcs.then(
					function(o_resp)
					{
						//console.log("f_process_feature_spatial_context - o_promise_gcs.then");
						//console.log(o_resp);

						let a_features = o_resp.geojson.features;
						let o_geojson_feature_geometry = null;
						if(a_features == null)
						{
							//console.log("f_process_feature_spatial_context - o_promise_gcs.then - about to call resolve");
							resolve();
						}
						else if(a_features.length == 1)
						{
							o_geojson_feature_geometry = a_features[0].geometry;
						}
						else// if(a_features.length > 1)
						{
							let a_geojson_geom = []; // all geometries will be of type multipolyline
							a_features.forEach(o_feature_i => { a_geojson_geom.push(o_feature_i.geometry); } );

							o_geojson_feature_geometry = NSGeoJson.f_get_geojson_feature_geometry_from_array_of_geojson_feature_geometries(a_geojson_geom);
						}
						
						NSObjDetailsPrivate.private_objs.o_details.feature.geometry = o_geojson_feature_geometry;
						NSObjDetailsPrivate.private_objs.o_details.feature.geometry_name = private_objs_global.CONSTS.s_CONST_INHERITED_GEOM_NAME;
						NSObjDetailsPrivate.private_objs.o_details.b_geometry_is_inherited = true;
						NSObjDetailsPrivate.private_objs.o_details.s_geometery_provider_table_urn = o_resp.geometry_provider_table_urn;

						this_.f_add_geojson_base_geometry_to_geojson_properties();
						
						let o_bbox = NSGeoJson.f_get_bounds_from_geojson_geometry(o_geojson_feature_geometry);
						NSObjDetailsPrivate.private_objs.o_details.bbox = o_bbox;

						
						//console.log("f_process_feature_spatial_context - o_promise_gcs.then - about to call load_table");

						let o_promise_load_table = NSDataModelInfo.f_load_table____returning_promise({			
							b_full_info: false,
							s_table_urn: o_resp.geometry_provider_table_urn
						});
						o_promise_load_table.then(function(b_error, s_message) 
						{
							//console.log("f_process_feature_spatial_context - o_promise_gcs.then - o_promise_load_table.then - about to call resolve");
							resolve();
						})
						.catch(err => { 
							console.log(err);
						});


					}
				);

			} );
			

		}
		else
		{
			return new Promise ( (resolve, reject) => {
				resolve();
			} );
		}

	},

	
	f_open_details_part_2: function ()
	{
		let this_ = this;
		let private_objs_global = this.private_objs;
		
		
		this_.f_process_feature_spatial_context().then(()=>
		{
			this_.f_open_details_part_3();
		});
		 return;

		
	},
	
	f_open_details_part_3: function ()
	{

		let private_objs = NSObjDetailsPrivate.private_objs;
		let o_details = private_objs.o_details;

		xCore.state.selected_objects = [];
		let s_feature_urn = o_details.s_urn;
		xCore.state.selected_objects.push( s_feature_urn );


		if(o_details.f_callback_when_all_info_is_loaded != null)
		{
			o_details.f_callback_when_all_info_is_loaded(o_details);
			delete o_details.f_callback_when_all_info_is_loaded;
		}




		this.f_set_title();
		

		this.o_read.f_open_details();
		
		this.f_show_read_section();
		
		this.f_add_highligt_geometry();

		if(o_details.b_go_to)
		{
			this.o_read.f_go_to_bounds();
		}

		this.f_set_coordinates_labels();
	},

	f_add_highligt_geometry: function ()
	{


		let s_geometry_internal_name = this.private_objs.o_details.feature.geometry_name; //NSObjDetailsPrivate.private_objs

		let s_geometry_button_id = 	"button_highlight_geometry_" + s_geometry_internal_name;
		let e_geometry_button = document.getElementById(s_geometry_button_id);

		if(e_geometry_button)
		{
			//e_geometry_button.onclick();
			this.o_read.f_geometry_button_click_(e_geometry_button);
			
		}
		
	},
	
	f_set_title: function ()
	{
		var private_objs = this.private_objs;
		
		var o_details = private_objs.o_details;
		var s_feature_urn = o_details.s_urn;
		var a_feature_urn_info = NSURN.f_get_urn_info(s_feature_urn);
		var s_schema_internal_name = a_feature_urn_info[1];
		var s_table_internal_name = a_feature_urn_info[2];
		
		var o_col_info = NSDataModelInfo.f_get_table_info(s_schema_internal_name, s_table_internal_name);

		private_objs.e_span_obj_details_title.innerHTML = '<div>' + o_col_info.external_name + '</div>';
		
	},

	f_set_coordinates_labels: function ()
	{
		var private_objs = this.private_objs;
		
		var o_details = private_objs.o_details;

		var o_geometry =  o_details.feature.geometry;

		private_objs.e_div_obj_details_coordinates.innerHTML = "";

		if (o_geometry === undefined || o_geometry.coordinates === undefined) {
			private_objs.e_div_obj_details_coordinates.style.display = "none";
			return;
		}

		private_objs.e_div_obj_details_coordinates.style.display = "";
		
		let a_centroid = NSFunctions.getCentroidFromCoordinates(o_geometry.coordinates);
		let a_x_y = NSCRS.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06(a_centroid); 
		let a_lng_lat = toLonLat(a_centroid);

		private_objs.e_div_obj_details_coordinates.innerHTML = `
			<div class="row g-0">
				<div class="col-6">x : ${a_x_y[0].toFixed(4)}</div>
				<div class="col-6">y : ${a_x_y[1].toFixed(4)}</div>
				<div class="col-6">lng : ${a_lng_lat[0].toFixed(4)}</div>
				<div class="col-6">lat : ${a_lng_lat[1].toFixed(4)}</div>
			</div>
		`;
	},
	
	f_show_hide_table_read: function (b_show_table)
	{
		var private_objs = this.private_objs;
		
		//AQUIIII TO DO TODO
	},
	
	
	o_read: 
	{
		private_objs: 
		{
			//e_div_as_res_table: null,
			
			o_table: null,
			
			table_data:
			{
				a_column_name: null
			},
			
		
		},
		
		f_open_details: function (  )
		{
			var private_objs = NSObjDetailsPrivate.private_objs;
			
			var o_details = private_objs.o_details;
			//var a_schema = o_details.schema;
			
			this.f_create_details_content( );
			
			NSPageSidepanel.f_enable_editortool();
			

			if(xCoreHelper.f_page_is_in_mini_client_mode())
			{
				let b_obj_details_info_area_should_remain_closed =  NSMiniClientMain.f_obj_details_info_area_should_remain_closed();
				if(b_obj_details_info_area_should_remain_closed)
				{
					return;	//to avoid the call to: NSPageSidepanel.f_show_sidepanel();
				}
				
			}
			
			NSPageSidepanel.f_show_sidepanel();
			
			
			
		},
		
		f_button_go_to_bounds_enable: function()
		{
			var private_objs_global = NSObjDetailsPrivate.private_objs;
			private_objs_global.e_button_go_to_bounds.removeAttribute("disabled");	
		},
		f_button_go_to_bounds_disable: function()
		{
			var private_objs_global = NSObjDetailsPrivate.private_objs;
			private_objs_global.e_button_go_to_bounds.setAttribute("disabled", null);
		},
		f_button_go_to_bounds_is_enabled: function()
		{
			var private_objs_global = NSObjDetailsPrivate.private_objs;
			var b_is_enabled = !private_objs_global.e_button_go_to_bounds.hasAttribute("disabled");
			return b_is_enabled;
		},
		f_go_to_bounds: function ()
		{
			let private_objs_global = NSObjDetailsPrivate.private_objs;
			
			let b_button_is_enabled = this.f_button_go_to_bounds_is_enabled();
			
			if(b_button_is_enabled==true)
			{

				//console.log("obj_details - f_go_to_bounds - b_button_is_enabled")
				//console.log(private_objs_global.o_bb)
				//window.private_objs_global__ =private_objs_global;

				let o_bb = private_objs_global.o_bb; // o_bb -> [x_min, y_min, x_max, y_max]
				let a_bb = o_bb;
				let o_fit_options = {
					padding: [10, 10, 10, 10],	//Values in the array are top, right, bottom and left padding.
					duration: 500, 				//ms
				};

				let b_bbox_is_point = (a_bb[0] == a_bb[2] && a_bb[1] == a_bb[3]) ? true : false;
				
				if(b_bbox_is_point)
				{
					o_fit_options.maxZoom = NSObjDetailsPrivate.private_objs.settings.go_to_bounds_point_max_zoom;
				}

				NSModule_Map.f_get_map().getView().fit(a_bb, o_fit_options);
			}
			
		},
		
		f_button_edit_details_show: function()
		{
			var private_objs_global = NSObjDetailsPrivate.private_objs;
			private_objs_global.e_button_edit_details.style.display = '';
		},
		f_button_edit_details_hide: function()
		{
			var private_objs_global = NSObjDetailsPrivate.private_objs;
			if(private_objs_global.e_button_edit_details)
				private_objs_global.e_button_edit_details.style.display = 'none';
		},
		f_button_edit_details_enable: function()
		{
			var private_objs_global = NSObjDetailsPrivate.private_objs;
			private_objs_global.e_button_edit_details.removeAttribute("disabled");	
		},
		f_button_edit_details_disable: function()
		{
			var private_objs_global = NSObjDetailsPrivate.private_objs;
			private_objs_global.e_button_edit_details.setAttribute("disabled", null);
		},
		f_button_edit_details_is_enabled: function()
		{
			var private_objs_global = NSObjDetailsPrivate.private_objs;
			var b_is_enabled = !private_objs_global.e_button_edit_details.hasAttribute("disabled");
			return b_is_enabled;
		},
		f_edit_details: function ()
		{
			var private_objs_global = NSObjDetailsPrivate.private_objs;
			
			var b_button_is_enabled = this.f_button_edit_details_is_enabled();
			
			if(b_button_is_enabled==true)
			{
				var o_details = private_objs_global.o_details;
				
				NSObjDetailsEdit.f_edit_details(o_details);
			}
			
		},
	
		f_create_details_content: function(  )
		{
			var private_objs_global = NSObjDetailsPrivate.private_objs;
			
			var o_details = private_objs_global.o_details;
			var a_schema = private_objs_global.o_details.schema;
			var o_bbox = o_details.bbox;
			var o_feature = o_details.feature;
			var o_joined_object_counts = o_details.joined_object_counts;
			
			
			var o_bb = null;
			if(o_bbox !=null)
			{
				o_bb = o_bbox
				
				
				this.f_button_go_to_bounds_enable();
			}
			else
			{
				this.f_button_go_to_bounds_disable();
			}
			
			
			private_objs_global.o_bb = o_bb;
			
			this.f_initialize_table();
			
			this.f_fill_table( );
			
			
		},
		
		f_initialize_table: function()
		{	
			var this_ = this;
			var private_objs = this.private_objs;
			var private_objs_global = NSObjDetailsPrivate.private_objs;
			
			//	field_name, field_value
			var a_column_name = ["Propriedade", "Valor"];
			var aTH_CSS = [];
			var aTD_CSS = [];
			for(var i=0; i<a_column_name.length; i++)
			{
				aTH_CSS.push("details-table-cell")
				aTD_CSS.push("details-table-cell")
			}
			
			private_objs.table_data.a_column_name = a_column_name;
			
			if(private_objs.o_table != null)
			{
				private_objs.o_table.destroy();
				private_objs.o_table = null;
			}
			
			
			//table sort comparisson function
			var f_cmp_sel = function(o1,o2)
			{
				return NSObjDetailsPrivate.o_comparisson_struct.f_cmp_sel(o1,o2);
			}
			var f_cmp_input_cb = function(o1,o2)
			{
				return NSObjDetailsPrivate.o_comparisson_struct.f_cmp_input_cb(o1,o2);
			}
			var f_cmp_string = function(o1,o2)
			{
				return NSObjDetailsPrivate.o_comparisson_struct.f_cmp_string(o1,o2);
			}
			
			
			var aColumns = new Array();
			aColumns = aColumns.concat(a_column_name)

			var e_TableHolder = private_objs_global.e_table_container;         
			var sTableCSS = 'table table-sm table-bordered table-hover table-col-1-nowrap';//'table table-bordered table-striped table-hover';
			var sTR_CSS = [""];
			var sTR_SELECTED_CSS = "selected";//"active_tr";//"active";//"table_tr_selected";
			var b_multiple_selection = false;
			var b_multiple_selection_classic_style = true;
			var b_sortable = true;
			var a_b_col_sortable = [true, false];//null;
			//var a_sort_cmp_function = null;
			var a_sort_cmp_function = [f_cmp_string, f_cmp_string];
			
			
			var o_in = {
				eHTMLHolder: e_TableHolder, 
				aColumns: aColumns, 
				sTableCSS: sTableCSS, 
				aTH_CSS: aTH_CSS, 
				aTD_CSS: aTD_CSS, 
				sTR_CSS: sTR_CSS, 
				sTR_SELECTED_CSS: sTR_SELECTED_CSS, 
				b_multiple_selection: b_multiple_selection, 
				b_multiple_selection_classic_style: b_multiple_selection_classic_style,
				b_sortable: b_sortable,
				a_b_col_sortable: a_b_col_sortable,    // default b_sortable determines if all are sortable or not
				a_sort_cmp_function: a_sort_cmp_function, //    ->  a[f(o1,o2)]    -> f returns true if o1 < o2 , default string comparisson...
			};
			
			var table = new NSTables.Objs.Table(o_in);
			private_objs.o_table = table;	
			
			//------------------------------------------
			//Event Handlers:
			//table
			var this_ = this;
			table.addRowClickEventFunction(
				function () {
				  //alert("row selected!");
				  this_.f_table_on_select_handler_();
			});
			
			//refreshing visibility:
			var b_show_table =  (a_column_name.length > 0)? true: false;
			NSObjDetailsPrivate.f_show_hide_table_read(b_show_table);

		},
		f_table_on_select_handler_: function()
		{
			var private_objs = this.private_objs;
			var o_table = private_objs.o_table;
			var a_selected_keys = o_table.getSelection_keys();
			//key -> obj_details_table_read_row__ + s_field_i_external_name
			
			
		},
		f_fill_table: function(  )
		{
			let private_objs = this.private_objs;
			let private_objs_global = NSObjDetailsPrivate.private_objs;

			let o_details = private_objs_global.o_details;
//			let a_schema = private_objs_global.o_details.schema;
			let o_feature = o_details.feature;

			NSObjDetailsPrivate.f_remove_empty_properties_from_feature(o_feature);

			
			const ValueElementData = class {
				constructor(elem_id, f_onclick, s_HTML) {
				  this.elem_id = elem_id;
				  this.f_onclick = f_onclick;
				  this.s_HTML = s_HTML;
				}
			  };
			let a_value_col_elem_info = []; // [ValueElementData] -> elems that will have onclick behavior


			let table_data = new NSTables.Objs.DataTable();
			let a_column_name = private_objs.table_data.a_column_name;
			
			let s_schema_internal_name;
			let s_table_internal_name;
			
			let o_properties = o_feature.properties;
			let a_properties_keys = Object.keys(o_properties);

			let use_external_names_to_compare_with_schema = false;
			
									
			let s_urn = o_details.s_urn;
			let a_feature_urn_info = NSURN.f_get_urn_info(s_urn);
			s_schema_internal_name = a_feature_urn_info[1];
			s_table_internal_name = a_feature_urn_info[2];
			
			let o_col_info = NSDataModelInfo.f_get_table_info(s_schema_internal_name, s_table_internal_name);
			
			let a_col_info_field_internal_name = o_col_info.extra.a_ordered_visible_columns;

			let s_CONST_INHERITED_GEOM_NAME = private_objs_global.CONSTS.s_CONST_INHERITED_GEOM_NAME;
			let b_geometry_is_inherited = o_details.b_geometry_is_inherited;
			if(b_geometry_is_inherited)
			{
				a_col_info_field_internal_name = [].concat(a_col_info_field_internal_name);
				a_col_info_field_internal_name.push(s_CONST_INHERITED_GEOM_NAME);
			}

			//if page is in mini client mode, use mini client configured fields
			if(xCoreHelper.f_page_is_in_mini_client_mode())
			{
				let a_field_whitelist = NSMiniClientMain.f_get_table_property_whitelist(s_table_internal_name);
				if(a_field_whitelist != null && a_field_whitelist.length > 0)
				{
					let a_col_info_field_internal_name_original = a_col_info_field_internal_name;
					a_col_info_field_internal_name = [];
	
					a_col_info_field_internal_name_original.forEach((s_field_internal_name_i) =>
					{
						if( a_field_whitelist.indexOf(s_field_internal_name_i) > -1 )
						{
							a_col_info_field_internal_name.push(s_field_internal_name_i);
						}
					})
				}

			}

//			console.log("a_col_info_field_internal_name:"+a_col_info_field_internal_name);
			for(let i=0; i<a_col_info_field_internal_name.length; i++)
			{
				let s_field_internal_name_i = a_col_info_field_internal_name[i];
//				console.log(s_field_internal_name_i)
//				console.log(o_col_info)
				let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name_i);	
				/*
				ex:
					editable: true
					external_name:"Localiza��o Abate"
					geom_type:"simple_point"
					internal_name:"localizacao_abate"
					type:"geometry"
				*/

				if(b_geometry_is_inherited && s_field_internal_name_i == s_CONST_INHERITED_GEOM_NAME)	
				{
					// field info from geometry on provider table
					let o_provider_table_geometry_field_info = NSDataModelInfo.f_get_table_first_geometry_field_info_by_urn( o_details.s_geometery_provider_table_urn );
					
					o_field_info_i = {
						data_type:		o_provider_table_geometry_field_info.data_type,
						external_name:	o_provider_table_geometry_field_info.external_name,
						internal_name:	s_CONST_INHERITED_GEOM_NAME,	//this specific name makes mor visible that the property doen't belong to the table
						is_fk:			o_provider_table_geometry_field_info.is_fk,
						is_join:		o_provider_table_geometry_field_info.is_join
					};
				}
				
				

				let s_field_internal_name_db = (o_field_info_i.internal_name_db)? o_field_info_i.internal_name_db : s_field_internal_name_i;
				let b_field_is_present_on_obj = (a_properties_keys.indexOf(s_field_internal_name_db) > -1);
				
//				console.log("01 - a_properties_keys:"+a_properties_keys)	;
//				console.log("01 - s_field_internal_name_i:"+s_field_internal_name_i)	;
//				console.log("01 - s_field_internal_name_db:"+s_field_internal_name_db)	;

				let b_field_is_visible = (o_field_info_i.is_hidden == null || o_field_info_i.is_hidden == false )? true : false;
				if(b_field_is_present_on_obj && b_field_is_visible)
				{					
					let s_field_i_external_name = o_field_info_i.external_name;
					let s_field_i_value = o_properties[s_field_internal_name_db];

					let b_field_is_link = ( !(b_geometry_is_inherited && s_field_internal_name_i == s_CONST_INHERITED_GEOM_NAME) )?
						NSDataModelInfo.f_field_is_link(s_schema_internal_name, s_table_internal_name, s_field_internal_name_i)
						: false;
					
					let b_field_is_join_field = o_field_info_i.is_join;

					let b_field_is_geometry = NSDataTypes.f_type_is_geometry(o_field_info_i.data_type);
					
//					console.log("                             b_field_is_geometry="+b_field_is_geometry);
//					console.log("                             o_field_info_i.data_type="+o_field_info_i.data_type);


					let s_field_unit = o_field_info_i.unit;
					if(s_field_unit != null && s_field_unit != "")
					{
						s_field_i_external_name += " (" + s_field_unit+")";
					}
					
					let s_field_i_value_html;	
//					console.log("s_field_internal_name_i:"+s_field_internal_name_i)	;
//					console.log("b_field_is_join_field:"+b_field_is_join_field);
//					console.log("s_field_i_value:"+s_field_i_value);
					if(b_field_is_join_field && s_field_i_value>0)
					{
//						console.log("ca dentro");

						let s_internal_name_db = (o_field_info_i.internal_name_db)? o_field_info_i.internal_name_db : o_field_info_i.internal_name;
						let o_field_join_info = o_details.f_join_field_info_by_internal_name_db_and_external_col_urn(
																													s_internal_name_db, 
																													o_field_info_i.external_col_urn);
																													let s_href = (b_field_is_link)? "s_field_i_value" : "#";
						let join_count = o_field_join_info.join_count;
						if (join_count != null && join_count > 0)
						{
							let external_col_urn = o_field_join_info.external_col_urn
							let s_join_field_internal_name = NSURN.f_get_urn_table_name(external_col_urn);
							let s_join_field_internal_table_name = s_join_field_internal_name;
							let b_no_permission_for_join_table = private_objs_global.a_s_table_urn_without_permissions.some( 
								s_urn_i => NSURN.f_get_urn_table_name(s_urn_i) === s_join_field_internal_table_name 
							); // if table is present in the array, user has no permission to access it
							
							if( !xCoreHelper.f_page_is_in_mini_client_mode() 
								&& !b_no_permission_for_join_table
							)
							{
								let s_guid = "O_DETAILS_EDIT_VALUE_ELEM__" + NSFunctions.guidGenerator();
								s_field_i_value_html = 
												'<a href="' + s_href + '" \
												id="' + s_guid + '" \
												k_0="' + s_urn + '" \
												k_1="' + s_join_field_internal_name + '" \
												k_2="' + s_field_i_value + '" \
												k_3="' + external_col_urn + '" \
												><b>' + join_count + '</b></a>';

								a_value_col_elem_info.push(new ValueElementData(
									s_guid,
									function(elem){
										NSObjDetails.f_show_joins_(elem);
									},
									s_field_i_value_html
								));
							}
							else
							{
								s_field_i_value_html = 
												'<span> \
												<b>' + join_count + '</b></span>'

							}
						}
						else
						{
							s_field_i_value_html = 
											'<span> \
											<b>' + 0 + '</b></span>'
						}

										;
					}
					else if(b_field_is_geometry)
					{
						let s_guid = "obj_details_geom____" + NSFunctions.guidGenerator();
						//s_urn
						
						/*
						var 
						 '<a type="button" class="btn btn-primary" title="" onclick=""><span class=""><b></b></span></a>'
						 */
						 /* AQUIIIIIIIII TODO TO DO
						 var o_field_geo_value = s_field_i_value;
						 var b_geometry_exists = (o_field_geo_value != null && o_field_geo_value != "")? true : false;
						 var s_disabled_attribute = (b_geometry_exists)? '' : 'disabled="disabled"' ;
						 var buttonId = "button_highlight_geometry" //+ "_" + s_field_internal_name_i; (This will be needed to uncomment for highlight a geometry other than the first)
						 s_field_i_value_html = '<button id="' + buttonId + '"\
													k_0="' + s_urn + '" \
													k_1="' + s_field_internal_name_i + '" \
													k_2="' + s_guid + '" \
													' + s_disabled_attribute + '\
													type="button" class="btn btn-sm btn-default btn-xs" onclick="NSObjDetails.o_read.f_geometry_button_click_(this);" ><span class="glyphicon glyphicon-eye-open"></span></button>'																																					
						s_field_i_value_html +=  '<button id="button_draw_trail"\
													k_0="' + s_urn + '" \
													k_1="' + s_field_internal_name_i + '" \
													k_2="' + s_guid + '" \
													' + s_disabled_attribute + '\
													type="button" class="btn btn-sm btn-default btn-xs" title="Desenhar Trilho" onclick="NSObjDetails.o_read.f_draw_object_trail(this);" ><span class="glyphicon glyphicon-edit"></span></button>'
						s_field_i_value_html +=  '<button id="button_copy_trail"\
													k_0="' + s_urn + '" \
													k_1="' + s_field_internal_name_i + '" \
													k_2="' + s_guid + '" \
													' + s_disabled_attribute + '\
													type="button" class="btn btn-sm btn-default btn-xs" title="Copiar Trilho" onclick="NSObjDetails.o_read.f_copy_object_trail(this);" ><span class="glyphicon glyphicon-copy"></span></button>'													

												*/ 
						//s_field_i_value_html= "";

						let s_label_obj_details_button_copy_trail_tooltip = NSPageLabels.f_get_label_text_by_internal_name("obj_details_button_copy_trail_tooltip");

						let o_field_geo_value = s_field_i_value;
						let b_geometry_exists = (o_field_geo_value != null && o_field_geo_value != "")? true : false;
						let s_disabled_attribute = (b_geometry_exists)? '' : 'disabled="disabled"' ;
						//var buttonId = "button_highlight_geometry" //+ "_" + s_field_internal_name_i; (This will be needed to uncomment for highlight a geometry other than the first)
						let buttonId = "button_highlight_geometry" + "_" + s_field_internal_name_i;
						s_field_i_value_html = '<button id="' + buttonId + '"\
													k_0="' + s_urn + '" \
													k_1="' + s_field_internal_name_i + '" \
													k_2="' + s_guid + '" \
													' + s_disabled_attribute + '\
													type="button" class="btn btn-sm btn-outline-secondary" >' + EyeIcon + '</button>';
						
						a_value_col_elem_info.push(new ValueElementData(
							buttonId,
							function(elem){
								NSObjDetails.f_geometry_button_click_(elem);
							},
							s_field_i_value_html
						));

						let s_label_obj_details_button_draw_trail_tooltip = NSPageLabels.f_get_label_text_by_internal_name("obj_details_button_draw_trail_tooltip");
						buttonId = "button_draw_trail" + "_" + s_field_internal_name_i;
						s_field_i_value_html +=  '<button id="' + buttonId + '"\
													k_0="' + s_urn + '" \
													k_1="' + s_field_internal_name_i + '" \
													k_2="' + s_guid + '" \
													' + s_disabled_attribute + '\
													type="button" class="btn btn-sm btn-default btn-xs" title="' + s_label_obj_details_button_draw_trail_tooltip + '" >' + DrawIcon + '</button>'													

						a_value_col_elem_info.push(new ValueElementData(
							buttonId,
							function(elem){
								NSObjDetails.f_draw_object_trail_(elem);
							},
							s_field_i_value_html
						));

						buttonId = "button_copy_trail" + "_" + s_field_internal_name_i;
						s_field_i_value_html +=  '<button id="' + buttonId + '"\
													k_0="' + s_urn + '" \
													k_1="' + s_field_internal_name_i + '" \
													k_2="' + s_guid + '" \
													' + s_disabled_attribute + '\
													type="button" class="btn btn-sm btn-default btn-xs" title="' + s_label_obj_details_button_copy_trail_tooltip + '" >' + CopyIcon + '</button>'													

						a_value_col_elem_info.push(new ValueElementData(
							buttonId,
							function(elem){
								NSObjDetails.f_copy_object_trail_(elem);
							},
							s_field_i_value_html
						));
					
						/*s_field_i_value_html +=  '<button id="button_draw_trail"\
													k_0="' + s_urn + '" \
													k_1="' + s_field_internal_name_i + '" \
													k_2="' + s_guid + '" \
													' + s_disabled_attribute + '\
													type="button" class="btn btn-sm btn-default btn-xs" title="Desenhar Trilho" onclick="NSObjDetails.o_read.f_draw_object_trail(this);" ><span class="glyphicon glyphicon-edit"></span></button>'
						s_field_i_value_html +=  '<button id="button_copy_trail"\
													k_0="' + s_urn + '" \
													k_1="' + s_field_internal_name_i + '" \
													k_2="' + s_guid + '" \
													' + s_disabled_attribute + '\
													type="button" class="btn btn-sm btn-default btn-xs" title="Copiar Trilho" onclick="NSObjDetails.o_read.f_copy_object_trail(this);" ><span class="glyphicon glyphicon-copy"></span></button>'													
						*/

					}
					else if (b_field_is_link) // AQUIIIII TODO TO DO
					{
						if(s_field_i_value != null && s_field_i_value != "")
						{
							//Quick fix for hardcoded links in the DB
							let hardcoded_value = "http://sig.cm-cascais.pt";

							
							if(s_field_i_value.indexOf(hardcoded_value) > -1 && xCore.application.endpoints.link_field_prefix){
								let b_page_in_ext_context = xCore.application.b_page_in_ext_context;
								let link_field_prefix = (b_page_in_ext_context) ? xCore.application.endpoints.link_field_prefix.external
																				: xCore.application.endpoints.link_field_prefix.internal ;
								s_field_i_value = link_field_prefix + s_field_i_value.split(hardcoded_value)[1]
							}				
							//END Quick fix
							
							let s_href = s_field_i_value;
							let s_link_text = "Abrir";
							
							s_field_i_value_html  = 
										'<a href="' + s_href + '" target="_blank" ><b>' + s_link_text + '</b></a>'
										//+ s_button_create_obj_join_HTML
										;
						}
						else
						{
							s_field_i_value_html = "";
						}
						
					}
					else if( NSDataTypes.f_type_is_date_or_datetime(o_field_info_i.data_type) )
					{
						s_field_i_value_html = NSDateDatetime.NSDate.f_get_value_as_fe_presentation_date_string_vers_02(s_field_i_value);
					}
					else
					{
						let s_html_val;
						if( NSDataTypes.f_type_is_number_with_decimal_places(o_field_info_i.data_type) ) 
						{
							if(s_field_i_value != null && s_field_i_value != "")
							{
								let n = parseFloat(s_field_i_value);
								let i_dp = NSObjDetailsPrivate.private_objs.settings.decimal_places;	//decimal places
								
								s_html_val = NSFunctions.roundNumber(n, i_dp);
							}
							else
							{
								s_html_val = "";
							}
						}
						else
						{
							s_html_val = (s_field_i_value != null)? s_field_i_value :  "";
						}
						
						s_field_i_value_html = s_html_val;
					}
					
					let s_row_id = "obj_details_table_read_row__" + s_field_i_external_name;
					
					let a_row_values = [s_field_i_external_name, s_field_i_value_html];
					table_data.addRows([a_row_values], [s_row_id]);
					
				}
				
				
			}
			
			
			let table = private_objs.o_table;
			table.addRows(table_data);
			

			//AQUIIIIIIIII
			// Add onclick event to field value elements (table column "value")
			// [ValueElementData] 
			a_value_col_elem_info.forEach( (valueElemData) => {
				let elem_i = document.getElementById(valueElemData.elem_id);
				elem_i.onclick = function()
				{
					valueElemData.f_onclick(elem_i);
				}
			} );
			
		},
		f_draw_object_trail : function( domElement ){
			var geom_field = null;
			if( domElement && domElement.getAttribute("k_1") ){
				geom_field = domElement.getAttribute("k_1");
						
				if( NSObjDetailsPrivate.private_objs.o_details && NSObjDetailsPrivate.private_objs.o_details.feature && NSObjDetailsPrivate.private_objs.o_details.feature.properties){
					var someProperties = NSObjDetailsPrivate.private_objs.o_details.feature.properties;
										
					for( var aProp in someProperties){
						
						aPropTransformed = aProp.replace(String.fromCharCode(231) ,"c");
						aPropTransformed = aPropTransformed.replace(String.fromCharCode(227) ,"a");
						aPropTransformed = aPropTransformed.toLowerCase();

						if( aPropTransformed == geom_field)
							NSToolDraw.drawEditableTrailFromGeoJson(NSObjDetailsPrivate.private_objs.o_details.feature.properties[aProp] , true, false);
					}			
				}
			}			
		},
		f_copy_object_trail : function( domElement ){
			var geom_field = null;
			if( domElement && domElement.getAttribute("k_1") ){
				geom_field = domElement.getAttribute("k_1");
						
				if( NSObjDetailsPrivate.private_objs.o_details && NSObjDetailsPrivate.private_objs.o_details.feature && NSObjDetailsPrivate.private_objs.o_details.feature.properties){
					var someProperties = NSObjDetailsPrivate.private_objs.o_details.feature.properties;
										
					for( var aProp in someProperties){
						
						aPropTransformed = aProp.replace(String.fromCharCode(231) ,"c");
						aPropTransformed = aPropTransformed.replace(String.fromCharCode(227) ,"a");
						aPropTransformed = aPropTransformed.toLowerCase();

						if( aPropTransformed == geom_field){
							xCore.state.clipboard.trail = NSObjDetailsPrivate.private_objs.o_details.feature.properties[aProp] 
							xCore.state.clipboard.trail.mapCenter = gmaps.map.getCenter();
							NSMessages.f_show_information("O trilho do objecto seleccionado foi copiado!" , 1000);
						}						
					}			
				}
			}			
		},
		f_geometry_is_feature_base_geometry: function(s_geometry_internal_name)
		{

			let s_base_geometry_internal_name = NSObjDetailsPrivate.private_objs.o_details.feature.geometry_name;

			return s_geometry_internal_name == s_base_geometry_internal_name;

		},
		f_geometry_button_click_: function(e_)
		{
			var o_button_struct = NSObjDetailsPrivate.o_button_struct;
			
			var b_disabled = o_button_struct.f_button_is_disabled(e_);
			if(b_disabled)
			{
				return;
			}
			
			var private_objs_global = NSObjDetailsPrivate.private_objs;

			var o_details = private_objs_global.o_details;
			var o_feature = o_details.feature;
			var o_properties = o_feature.properties;
			
			var s_feature_urn = e_.getAttribute("k_0");
			var s_field_internal_name = e_.getAttribute("k_1");

			var o_field_geo_value = o_properties[s_field_internal_name];
			
			var b_active = o_button_struct.f_button_is_active(e_);

			if(!b_active)//	create/show geometry
			{
				NSFeaturesSelect.f_add_current_selection_highlight({urn: s_feature_urn, geometry: o_field_geo_value, parent: o_details.s_geometery_provider_table_urn});
			}
			else
			{
				NSFeaturesSelect.f_remove_current_selection_highlight();
			}
			
			o_button_struct.f_set_button_active_state(e_, !b_active);

		},
		f_copy_object_trail_: function(e_)
		{
			var o_button_struct = NSObjDetailsPrivate.o_button_struct;
			
			var b_disabled = o_button_struct.f_button_is_disabled(e_);
			if(b_disabled)
			{
				return;
			}
			
			var private_objs_global = NSObjDetailsPrivate.private_objs;

			var o_details = private_objs_global.o_details;
			var o_feature = o_details.feature;
			var o_properties = o_feature.properties;
			
			var s_feature_urn = e_.getAttribute("k_0");
			var s_field_internal_name = e_.getAttribute("k_1");

			var o_field_geo_value = o_properties[s_field_internal_name];
			
			
			NSGeometryClipboard.f_add_geometry(o_field_geo_value);
			let s_label_obj_details_geometry_copy_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_geometry_copy_message");
			NSMessages.f_show_information( s_label_obj_details_geometry_copy_message , 3000 );
			
			


		},
		f_draw_object_trail_: function(e_)
		{
			var o_button_struct = NSObjDetailsPrivate.o_button_struct;
			
			var b_disabled = o_button_struct.f_button_is_disabled(e_);
			if(b_disabled)
			{
				return;
			}
			
			var private_objs_global = NSObjDetailsPrivate.private_objs;

			var o_details = private_objs_global.o_details;
			var o_feature = o_details.feature;
			var o_properties = o_feature.properties;
			
			var s_feature_urn = e_.getAttribute("k_0");
			var s_field_internal_name = e_.getAttribute("k_1");

			var o_field_geo_value = o_properties[s_field_internal_name];
			let o_geojson_feature_geometry = o_field_geo_value;
			
			
			/* Cannot use this path because of inherited geometries
			let a_feature_urn_info = NSURN.f_get_urn_info(s_feature_urn);
			let s_schema_internal_name = a_feature_urn_info[1];
			let s_table_internal_name = a_feature_urn_info[2];
			//let s_field_internal_name = a_feature_urn_info[3];

			let o_col_info = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);
			var s_geometry_type = o_col_info.data_type;
			*/

			let s_geom_type = o_geojson_feature_geometry.type;
			if(NSGeoJson.Types.f_is_point(s_geom_type))
			{
				NSToolDraw.f_draw_marker_enable(o_geojson_feature_geometry);
			}
			else if(NSGeoJson.Types.f_is_polyline(s_geom_type)
					|| NSGeoJson.Types.f_is_multipolyline(s_geom_type))
			{
				NSToolDraw.f_draw_polyline_enable(o_geojson_feature_geometry);
			}
			else	//if(NSGeoJson.Types.f_is_polygon(s_geom_type)
					//	|| NSGeoJson.Types.f_is_multipolygon(s_geom_type))
			{
				NSToolDraw.f_draw_polygon_enable(o_geojson_feature_geometry);
			}


			let s_label_obj_details_geometry_draw_message = NSPageLabels.f_get_label_text_by_internal_name("obj_details_geometry_draw_message");
			NSMessages.f_show_information( s_label_obj_details_geometry_draw_message , 3000 );
			
			
		},
		
		f_show_joins_: function(e_)
		{
			let s_urn = e_.getAttribute("k_0");
			let s_join_field_internal_name = e_.getAttribute("k_1");
			//let s_feature_count = e_.getAttribute("k_2");
			let external_column_urn =  e_.getAttribute("k_3");

			let s_schema_internal_name;
			let s_table_internal_name;

			var a_feature_urn_info = NSURN.f_get_urn_info(s_urn);
			s_schema_internal_name = a_feature_urn_info[1];
			s_table_internal_name = a_feature_urn_info[2];
			
			var o_col_info = NSDataModelInfo.f_get_table_info(s_schema_internal_name, s_table_internal_name);
			//let s_field_internal_name_db = (o_col_info.internal_name_db)? o_col_info.internal_name_db : o_col_info.internal_name;
			// whether the internal_name is internal_db or not, this function will still return the field info:
			let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_join_field_internal_name);
			let s_field_internal_name_db = (o_field_info_i.internal_name_db)? o_field_info_i.internal_name_db : o_field_info_i.internal_name;

			var private_objs_global = NSObjDetailsPrivate.private_objs;
			var o_details = private_objs_global.o_details;

			//let o_join_info = this.f_join_field_info_by_internal_name_db_and_external_col_urn(s_field_internal_name_db, external_column_urn);
			let o_join_info = o_details.f_join_field_info_by_internal_name_db_and_external_col_urn(s_field_internal_name_db, external_column_urn);
			

			let o_in = {
				object_urn: s_urn,
				//relationship_property: s_join_field_internal_name,
				//feature_count: s_feature_count
				local_col: o_join_info.local_col,
				external_col_urn: o_join_info.external_col_urn,				
				join_count: o_join_info.join_count,
				join_ids: o_join_info.join_ids
			};
			NSObjJoinList.f_run(o_in);
			
		}
		
		
	},
	
	
	o_button_struct: 
	{
		f_button_is_active: function(e_button)
		{
			var sClass = 'active';
			var sClassesList = e_button.getAttribute('class');
			
			var b_is_active = NSFunctions.elemClass_HasClass(sClassesList, sClass);
			return b_is_active;
		},
		f_button_is_disabled: function(e_button)
		{
			var b_disabled = e_button.hasAttribute('disabled');
			return b_disabled;
		},
		f_set_button_active_state: function(e_button, b_active)
		{
			var sClass = 'active';
			var sClassesList = e_button.getAttribute('class');
			
			if(b_active){
				sClassesList = NSFunctions.elemClass_addClass(sClassesList, sClass)
			}
			else{
				sClassesList = NSFunctions.elemClass_RemoveClass(sClassesList, sClass)
			}
			e_button.setAttribute('class', sClassesList);
		},
		f_set_button_disabled_state: function(e_button, b_disabled)
		{
			var s_attribute = 'disabled';
			if(b_disabled)
			{
				e_button.addAttribute(s_attribute, s_attribute);
			}
			else
			{
				e_button.removeAttribute(s_attribute);
			}
		}
	},
	

	o_comparisson_struct : 
	{
		//table sort functions:
		//compare select HTML
		f_cmp_sel : function(o1_in, o2_in)
		{
			/*
			var f_find_select_value_desc = function(s_select)
			{
				var s_= s_select;
				var e_ = document.createElement('tmp');
				e_.innerHTML = s_;
				var a_ = e_.getElementsByTagName('option');
				for(var i=0; i< a_.length; i++)
				{
					var e_i = a_[i];
					if (e_i.hasAttribute('selected'))
					{
						return e_i.innerHTML;
					}
				}
			}
			*/
			var f_find_select_value_desc = function(s_select)
			{
				var s_= s_select;
				// "...selected="selected"...>VALUE_DESC</option>..."
				//var i = s_.indexOf('selected="selected"')
				var s1 = s_.split('selected="selected"')[1];
				var s2 = s1.split("</option>")[0];
				var s_desc = s2.split(">")[1];
				
				return s_desc;
				
			}
			
			var o1 = f_find_select_value_desc(o1_in);
			var o2 = f_find_select_value_desc(o2_in);
			
			//return o1 < o2;
			return this.f_cmp_string(o1, o2);
			
			
		},
		//compare input checkbox HTML
		f_cmp_input_cb : function(o1_in, o2_in)
		{
		/*
			var f_find_select_value_desc = function(s_input_cb)
			{
				var s_= s_input_cb;
				var e_ = document.createElement('tmp');
				e_.innerHTML = s_;
				var a_ = e_.getElementsByTagName('input');
				
					var e_0 = a_[0];
					if (e_0.hasAttribute('checked'))
					{
						return 1;
					}
					else
					{
						return 0;
					}
			}
			*/
			let f_find_select_value_desc = function (s_input_cb)
			{
				if (s_input_cb.indexOf("checked") >-1)
				{
					return 1;
				}
				else
				{
					return 0;
				}
			}
			
			var o1 = f_find_select_value_desc(o1_in);
			var o2 = f_find_select_value_desc(o2_in);
			
			return o1 < o2;
			
			
		},
		
		//simple comparissons:
		f_cmp_string : function (o1, o2)
		{
			var b_int = false;
			return this.f_cmp_string_or_int(o1, o2, b_int);
		},
		f_cmp_string_or_int : function (o1, o2, b_int)
		{
			var this_ = this;
			var f;
			if(b_int)
			{
				f = function(a,b){
					var i_a = (parseInt(a))? parseInt(a) : "Not a number";
					var i_b = (parseInt(b))? parseInt(b) : "Not a number";
					
					if(i_b == "Not a number")
					{
						return -1;
					}
					else if(i_a == "Not a number")
					{
						return 1;
					}
					else if(i_a>=i_b)
					{
						return 1;
					}
					else
					{
						return -1;
					}
				}
			}
			else
			{
				f = function(a,b){
					var s_a = a + "";
					var s_b = b + "";
				
					/*
					if(s_a>=s_b)
					{
						return 1;
					}
					else
					{
						return -1;
					}
					*/
					return this_.f_text_comparison(s_a, s_b);
				}
			
			}
			
			return f(o1,o2);
		},
		f_text_comparison : function (s_1_param, s_2_param)
		{
			var f_format_s = function(s)
			{
				s = s.toLowerCase();

				s = NSFunctions.StringReplaceAll(s, "�","a");
				s = NSFunctions.StringReplaceAll(s, "�","a");
				s = NSFunctions.StringReplaceAll(s, "�","a");
				s = NSFunctions.StringReplaceAll(s, "�","a");
				s = NSFunctions.StringReplaceAll(s, "�","e");
				s = NSFunctions.StringReplaceAll(s, "�","e");
				s = NSFunctions.StringReplaceAll(s, "�","e");
				s = NSFunctions.StringReplaceAll(s, "�","i");
				s = NSFunctions.StringReplaceAll(s, "�","i");
				s = NSFunctions.StringReplaceAll(s, "�","i");
				s = NSFunctions.StringReplaceAll(s, "�","o");
				s = NSFunctions.StringReplaceAll(s, "�","o");
				s = NSFunctions.StringReplaceAll(s, "�","o");
				s = NSFunctions.StringReplaceAll(s, "�","o");
				s = NSFunctions.StringReplaceAll(s, "�","u");
				s = NSFunctions.StringReplaceAll(s, "�","u");
				s = NSFunctions.StringReplaceAll(s, "�","u");
				
				return s;
			}
		
			var s_1 = f_format_s(s_1_param);
			var s_2 = f_format_s(s_2_param);
			/*
			var i_res = (s_1 > s_2)? 1 : -1;
			return i_res;	
			*/
			return s_1 < s_2;
			
		}
	
	},
	
	objs:
	{

		/**

			@property local_col			col internal_name, ex "arvore"
			@property local_col_db		col internal_name in db, ex "id"
			@property external_col_urn	ex: "urn__SEP__field__SEP__teste_01__SEP__tabela_03__SEP__id_tabela_01"
			@property join_count		ex: "2"
			@property join_ids			ex: "2,4"

			o_in:
			{
				local_col,				-> col internal_name, ex "arvore"
				local_col_db			-> col internal_name in db, ex "id"
				external_col_urn,		-> ex: "urn__SEP__field__SEP__teste_01__SEP__tabela_03__SEP__id_tabela_01"
				join_count,				-> ex: "2"
				join_ids				-> ex: "2,4"
			}
		*/
		JoinInfo: function(o_in)
		{
			this.local_col = o_in.local_col;
			this.local_col_db = o_in.local_col_db;
			this.external_col_urn = o_in.external_col_urn;
			this.join_count = o_in.join_count;
			this.join_ids = o_in.join_ids;
		},

		/**
		 @description
			o_in:
			{
				tree_node_id,
				s_urn,
				bbox,
				feature,
				joined_object_counts,
				b_is_icon,
				a_icon_size_xy,
				b_go_to,
				b_geometry_is_inherited			// Spatial context is inherited
				s_geometery_provider_table_urn	// table urn of spatial context provider

				f_callback_when_all_info_is_loaded	// callback function to be called when all data is loaded
			}
		*/
		ObjDetails: function(o_in)
		{
			this.tree_node_id = o_in.tree_node_id;
			this.s_urn = o_in.s_urn,
			this.bbox = o_in.bbox,
			this.feature = o_in.feature,
			this.joined_object_counts = o_in.joined_object_counts,
			this.b_is_icon = o_in.b_is_icon,
			this.a_icon_size_xy = o_in.a_icon_size_xy,
			this.b_go_to = o_in.b_go_to,
			this.b_geometry_is_inherited = o_in.b_geometry_is_inherited,
			this.s_geometery_provider_table_urn = o_in.s_geometery_provider_table_urn			

			this.f_callback_when_all_info_is_loaded = o_in.f_callback_when_all_info_is_loaded;
		},

		init: function()
		{


			/**
				@param internal_name_db
				@param external_col_urn		only used if join is_target

				internal_name_db -> if join is_fk use "internal_name" 
									if join is_target use "internal_name_db"
				external_col_urn -> only used if join is_target

				ex:
					internal_name_db: "id"			* -> if join is of fk type use internal_name
					external_col_urn: "urn__SEP__field__SEP__municipio__SEP__arvore_intervencao__SEP__arvore_id"
			*/
			this.ObjDetails.prototype.f_join_field_info_by_internal_name_db_and_external_col_urn = function(internal_name_db, external_col_urn)
			{
				let o_joined_object_counts = this.joined_object_counts;
				let b_external_col_urn_is_null = (external_col_urn == null || external_col_urn == "")? true : false;

				// a_external_join_info = [{objs.JoinInfo}]
				let a_all_join_info = o_joined_object_counts.a_all_join_info;
				for (let i=0; i<a_all_join_info.length; i++)
				{
					let o_join_field_info = a_all_join_info[i];
					if(
						o_join_field_info.local_col_db == internal_name_db
						&& 
						(b_external_col_urn_is_null || o_join_field_info.external_col_urn == external_col_urn)					
					)
					{
						return o_join_field_info;
					}
					
				}
				
				return null;
				
			}

		}

	}
	
}